document.addEventListener('DOMContentLoaded', function () {
  // --- Variant picker: sync option selects to the real variant id ---
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantsJson = form.querySelector('[data-variants-json]');
    if (!variantsJson) return;
    var realForm = form.closest('form');
    var variants = JSON.parse(variantsJson.textContent);
    var optionSelects = form.querySelectorAll('[data-option-select]');
    var idInput = form.querySelector('[data-variant-id-input]');
    var priceEl = form.querySelector('[data-price]');
    var compareEl = form.querySelector('[data-compare-price]');
    var addBtn = form.querySelector('[data-add-btn]');

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function currentVariant() {
      var chosen = Array.prototype.map.call(optionSelects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }

    var addLabel = addBtn ? (addBtn.getAttribute('data-add-label') || 'Agregar al carrito') : '';
    var soldOutLabel = addBtn ? (addBtn.getAttribute('data-sold-out-label') || 'Agotado') : '';

    function update() {
      var variant = currentVariant();
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = soldOutLabel; }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (variant.available) { addBtn.disabled = false; addBtn.textContent = addLabel; }
        else { addBtn.disabled = true; addBtn.textContent = soldOutLabel; }
      }
    }

    optionSelects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });

  // --- Quantity steppers (product page + cart) ---
  document.querySelectorAll('[data-qty-wrap]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-qty-input]');
    wrap.querySelectorAll('[data-qty-btn]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var delta = parseInt(btn.getAttribute('data-qty-btn'), 10);
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = next;
        if (wrap.hasAttribute('data-auto-submit')) {
          input.closest('form').requestSubmit ? input.closest('form').requestSubmit() : input.closest('form').submit();
        }
      });
    });
  });

  // --- Add to cart via AJAX so the header badge updates without reload ---
  document.querySelectorAll('[data-product-form]').forEach(function (wrap) {
    var form = wrap.closest('form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = wrap.querySelector('[data-add-btn]');
      var originalLabel = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Agregando…'; }
      var idField = wrap.querySelector('[data-variant-id-input]');
      if (!idField || !idField.value) { if (btn) { btn.disabled = false; btn.textContent = originalLabel; } return; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: idField.value, quantity: parseInt((wrap.querySelector('[data-qty-input]') || {}).value || 1, 10) })
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error'); }); return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          if (btn) { btn.textContent = '¡Agregado!'; setTimeout(function () { btn.textContent = originalLabel; btn.disabled = false; }, 1200); }
        })
        .catch(function (err) {
          if (btn) { btn.textContent = originalLabel; btn.disabled = false; }
          alert(err.message || 'No se pudo agregar el producto.');
        });
    });
  });
});
